
/**
 * @fileOverview bCom Cart Item Count View
 * @Author: a3xs8zz
 * @modified 06/10/2015
 *
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('views/bcomCartView',['require','jquery','lib/Util'],function (require) {
        var $ = require('jquery');
        var Util = require('lib/Util');

		var bcomCartView = function($cartLi){
			this.container = $cartLi;
			this.itemCount = this.container.find('.js-cartValue');
			this.wrapper = $('<span class="MMM--icnValue_inner"></span>');
			this.cartUrl = '/L7/ebus/bcomportalservice/qw5/rest/v2/bComCanadaSite/carts/lastUsedCart/cartLineItemCount';
			this.cartAttempts = 0;
			this.hideCart = false;
			this.cartHref = this.container.children('a').attr('href').trim();

			// If the cart href is '#' or empty and the site has been configured to require a URL (bCom), then hide the cart
			if((this.cartHref === '#' || this.cartHref === '') && window.SETTINGS.cartURLRequired === true){
				this.hideCart = true;
			}

			// Hide cart if above criteria is met
			if(this.hideCart){
				this.container.hide();
			} else{
				this.init();
			}
		};

		bcomCartView.prototype.init = function(){
			var env = SETTINGS.environment;		//returns qa, dev, etc
			var api = {};						//mapping of url segments from themeconfig

			if(!!urlHash['cartJSON']){
				this.cartUrl = decodeURIComponent(urlHash['cartJSON']);

				$debug('Cart AJAX override found via URL hash: ' + this.cartUrl, 'bcomCartView');
			} 
			else if(window.SETTINGS.bComConstants && window.SETTINGS.bComConstants.environmentVars){
				//uses environment based theme config mapping
					api = {
						urlPrefix : SETTINGS.bComConstants.environmentVars[env].apiPrefix + SETTINGS.bComConstants.environmentVars[env].environment + SETTINGS.bComConstants.environmentVars[env].apiMid,
    					urlSuffix : SETTINGS.bComConstants.environmentVars[env].apiSuffix,
    					apiKey : SETTINGS.bComConstants.apiKeys
    				};
				this.cartUrl =  api.urlPrefix + api.apiKey.cartAjax + api.urlSuffix;
				$debug('Environmental Cart AJAX override found via theme configuration: ' + this.cartUrl, 'bcomCartView');
			}
			else if(!!window.SETTINGS.bComConstants.urls.cartAjax){
				//theme config doesn't have environment mapping
				this.cartUrl = window.SETTINGS.bComConstants.urls.cartAjax;

				$debug('Cart AJAX override found via theme configuration: ' + this.cartUrl, 'bcomCartView');
			}
			else {
				$msg('Cart AJAX failure...');
			}

			$debug('Cart API URL: ' + this.cartUrl, 'bcomCartView');

			this.getCartData(this.cartUrl);

			return this;
		};

		/*  This method initializes the AJAX call to the bCom Cart API service with the given URL.
			Five attempts to load the cart will be made before the module errors out and quits.
		*/
		bcomCartView.prototype.getCartData = function(cartUrl){
			var self = this;

			if(this.cartAttempts < 5){
				this.cartAttempts++;

				$.ajax({
					url: cartUrl,
					success: function(data){
						self.updateCartCount(data);
					},
					error: function(){
						$debug('Error loading bCom Cart information, Attempt #' + self.cartAttempts, 'bcomCartView');
										
						self.getCartData(cartUrl);
					}
				});
			}

			return this;
		};

		/*  This method updates the cart text based on the results of the bCom Cart API.
		*/
		bcomCartView.prototype.updateCartCount = function(cartInfo){
			$debug('bCom Cart API success: ', 'bcomCartView');
			$debug(cartInfo, 'bcomCartView');
			$debug('bCom Cart Item Count: ' + cartInfo.data.itemCount, 'bcomCartView');

			if(cartInfo.data !== undefined && cartInfo.data.itemCount !== undefined){
				this.itemCount.html(this.wrapper.text(cartInfo.data.itemCount));
			}

			return this;
		};

		return bcomCartView;
	});
}(MMMRequire));